<template>
	<section class="grid-products">
		<GridProductsHeading
			:heading="heading"
			:topLink="topLink"
			:uspLinks="uspLinks"
			class="margin-bottom-m"
		/>

		<SwiperCarousel
			v-if="loading"
			class="carousel"
			:slidesPerView="dummies"
			scrollbar
		>
			<SwiperCarouselSlide
				v-for="(dummy, index) in dummies * 2"
				:key="index"
			>
				<LazyFakeProduct
					:key="dummy"
					loading
				/>
			</SwiperCarouselSlide>
		</SwiperCarousel>

		<SwiperCarousel
			v-if="products.length > 0 && !loading"
			:slidesPerView="slidesToShow"
			scrollbar
			class="carousel"
			lazyLoad="progressive"
		>
			<SwiperCarouselSlide
				v-for="(product, index) in products"
				:key="product.productId || product.key || `product-${index}`"
			>
				<slot
					name="content"
					:product="product"
					:rawProduct="getRawProduct(product.productId)"
				>
				</slot>
			</SwiperCarouselSlide>
		</SwiperCarousel>
	</section>
</template>

<script>
export default defineNuxtComponent({
	mixins: [],

	props: {
		loading: {
			type: Boolean,
			default: true,
		},
		dummies: {
			type: Number,
		},
		products: {
			type: Array,
			default: () => [],
		},
		contentSize: {
			type: String,
		},
		topLink: {
			type: Object,
		},
		uspLinks: {
			type: Array,
		},
		addToCart: {
			type: Boolean,
		},
		heading: {
			type: String,
		},
		hidePayNow: {
			type: Boolean,
		},
		useNewProductPage: {
			type: Boolean,
		},
		quickAdd: {
			type: Boolean,
		},
		rawProducts: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			width: window?.innerWidth,
		};
	},

	computed: {
		slidesToShow() {
			const mobileBreakpoint = 768;
			const isMobile = this.width < mobileBreakpoint;
			if (this.width <= 300) {
				return 1;
			}
			if (this.products.length >= 4) {
				if (!isMobile) {
					if (this.width > 850 && this.width < 1080) {
						return 3;
					} else if (this.width <= 850) {
						return 2;
					}
				} else {
					if (this.width > 550 && this.width <= 700) {
						return 3;
					} else if (this.width >= 375 && this.width <= 550) {
						return 2;
					} else if (this.width < 375) {
						return 1;
					}
					return 4;
				}
				return 4;
			} else if (this.products.length >= 2) {
				if (this.width < 520 && this.width >= 400) {
					return 2;
				} else if (this.width <= 400) {
					return 1;
				}
				return this.products.length == 3 ? 3 : 2;
			}
			return 1;
		},
	},

	methods: {
		getRawProduct(productId) {
			return this.rawProducts?.find((product) => product.id === productId);
		},
		handleResize() {
			this.width = window?.innerWidth;
		},
	},

	mounted() {
		window.addEventListener("resize", this.handleResize);
	},

	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
	},
});
</script>

<style lang="scss" scoped></style>
